export enum EnumTipoProductoCapacidad {
  Intradiario = 1,
  Diario,
  Mensual,
  Trimestral,
  Anual,
  Restriccion,
  Indefinido,
  Semanal
}
